import { Modal, ModalBody } from "reactstrap";
import ColorsCircles from "./colors-roles";
import { useEffect, useState } from "react";
import { useSkillsAction } from "../../../../services/actions/skills.action";
import { ButtonLoading } from "../../../../components/buttons/button-loading";
import toast from "react-hot-toast";
import { useRecoilValue } from "recoil";
import { crudSkillsAtom } from "../../../../services/atoms/skills.atom";

const EditSkillModal = (props) => {
  const { open, toggle, skill, setSkill, update } = props;
  const skillResolver = useRecoilValue(crudSkillsAtom);
  const [selectedColors, setSelectedColors] = useState([]);
  const { updateSkill } = useSkillsAction();

  useEffect(() => {
    setSelectedColors(skill?.colorType);
  }, []);

  const handleChange = (key, value) =>
    setSkill((prevValues) => ({ ...prevValues, [key]: value }));
  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      if (selectedColors.length < 2) {
        setSelectedColors((prevSelectedColors) => [
          ...prevSelectedColors,
          value,
        ]);
      } else {
        e.preventDefault();
      }
    } else {
      setSelectedColors((prevSelectedColors) =>
        prevSelectedColors.filter((color) => color !== value)
      );
    }
  };

  const isCheckboxDisabled = (color) => {
    return selectedColors.length === 2 && !selectedColors.includes(color);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    let newData = Object.fromEntries(data.entries());
    newData = { ...newData, id: skill?.id, colorType: selectedColors };
    updateSkill(newData, () => {
      toast.success("Competencia actualizada exitosamente", { duration: 4000 });
      toggle();
      update();
    });
  };
  return (
    <Modal isOpen={open} toggle={toggle}>
      <div className="gm-modal-header">
        <div className="gm-modal-title-container">
          <div className="gm-modal-title">Editar Competencia</div>
        </div>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={toggle}
        />
      </div>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div className="gm-modal-form-container">
            <div className="gm-modal-form-section">
              <div className="gm-modal-form-group">
                <div className="gm-modal-input-group">
                  <label htmlFor="name">Nombre</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    maxLength={50}
                    value={skill?.name}
                    onChange={(e) => handleChange("name", e.target.value)}
                  />
                </div>
              </div>
              <div className="gm-modal-form-group">
                <div className="gm-modal-input-group">
                  <label htmlFor="description">Descripción</label>
                  <textarea
                    type="text"
                    id="description"
                    name="description"
                    required
                    maxLength={500}
                    value={skill?.description}
                    onChange={(e) =>
                      handleChange("description", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="gm-modal-form-group">
                <div className="gm-modal-input-group">
                  <label>Color asociado a la competencia: </label>
                  <div className="gm-modal-checkbox-section">
                    <label>
                      <ColorsCircles colors="azul" />
                      Estructurado / Azul
                    </label>
                    <input
                      className="input-checkbox"
                      type="checkbox"
                      value="azul"
                      checked={selectedColors.includes("azul")}
                      onChange={handleCheckboxChange}
                      disabled={isCheckboxDisabled("azul")}
                    />
                    <label htmlFor="colorType">
                      {" "}
                      <ColorsCircles colors="rojo" /> Dominante / Rojo
                    </label>
                    <input
                      className="input-checkbox"
                      type="checkbox"
                      value="rojo"
                      checked={selectedColors.includes("rojo")}
                      onChange={handleCheckboxChange}
                      disabled={isCheckboxDisabled("rojo")}
                    />
                    <label htmlFor="colorType">
                      {" "}
                      <ColorsCircles colors="amarillo" />
                      Influyente / Amarillo
                    </label>
                    <input
                      className="input-checkbox"
                      type="checkbox"
                      value="amarillo"
                      checked={selectedColors.includes("amarillo")}
                      onChange={handleCheckboxChange}
                      disabled={isCheckboxDisabled("amarillo")}
                    />
                    <label htmlFor="colorType">
                      {" "}
                      <ColorsCircles colors="verde" />
                      Sostenedor / Verde
                    </label>
                    <input
                      className="input-checkbox"
                      type="checkbox"
                      value="verde"
                      checked={selectedColors.includes("verde")}
                      onChange={handleCheckboxChange}
                      disabled={isCheckboxDisabled("verde")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="gm-modal-buttons">
            <button
              type="button"
              className="gm-secondary-button"
              onClick={toggle}
            >
              Cancelar
            </button>
            <ButtonLoading
              className="gm-primary-button"
              type="submit"
              buttonLabel="Guardar"
              disabled={selectedColors.length < 1 || selectedColors.length > 2}
              loading={skillResolver.loading}
            />
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default EditSkillModal;
